import { Component, Host, h, Prop, Listen, State, Element } from '@stencil/core';
import { isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-stage-large',
  styleUrl: 'bam-stage-large.scss',
  shadow: false,
})
export class BamStageLarge {
  @Element() el: HTMLElement;

  @State() isMobile: boolean = false;

  @Prop() color!: 'blue' | 'purple' | 'green' | 'red' | 'yellow';
  @Prop() containerSize: '' | 'is-fluid' | 'is-detail-page' | 'is-compact' | 'is-blog-page' | 'is-wide';
  @Prop() subline?: string;
  @Prop() text?: string;
  @Prop() alt?: string;
  @Prop() inverted: boolean | undefined;
  @Prop() shape?: boolean;
  @Prop() shapeVariation?: '1' | '2' | '3';
  @Prop() shapeRotation?: '0' | '90' | '180' | '270';
  @Prop() images?: string;
  @Prop() video?: string;

  private mobileElements: NodeListOf<HTMLElement>;
  private desktopElements: NodeListOf<HTMLElement>;

  @Listen('resize', { target: 'window' })
  async resizeHandler() {
    this.setIsMobile();
  }

  setIsMobile() {
    this.isMobile = isPlatform('mobile') || isPlatform('tablet');

    if(this.isMobile) {
      this.mobileElements.forEach(el => el.ariaHidden = "false");
      this.desktopElements.forEach(el => el.ariaHidden = "true");
    } else {
      this.mobileElements.forEach(el => el.ariaHidden = "true");
      this.desktopElements.forEach(el => el.ariaHidden = "false");
    }
  }

  connectedCallback() {
    this.mobileElements = this.el.querySelectorAll('.desktop\\:hidden');
    this.desktopElements = this.el.querySelectorAll('.mobile\\:hidden, .touch\\:hidden')

    this.setIsMobile();
  }

  render() {
    return (
      <Host
        class={{
          'is-video': !!this.video,
        }}
      >
        <slot name="headline-mobile"></slot>
        <bal-stage
          size="large"
          container-size={this.containerSize}
          // inverted={this.inverted}
          color={this.color}
          shape={(this.video && this.shape) || (!this.isMobile && this.shape)}
          shape-variation={this.shapeVariation}
          shape-rotation={this.shapeRotation}
        >
          {this.images && !this.video && <bal-stage-image srcSet={this.images}></bal-stage-image>}
          {!!this.video && this.isMobile && this.images && <bal-stage-image srcSet={this.images}></bal-stage-image>}
          {this.video && !this.isMobile && <video class="bam-stage-large__video" aria-hidden="true" src={this.video} preload="auto" autoplay poster="" loop muted></video>}
          <bal-stage-body>
            <slot name="desktop"></slot>
          </bal-stage-body>
        </bal-stage>
        <slot name="mobile"></slot>
      </Host>
    );
  }
}
